module.exports = __webpack_public_path__ + "static/media/after.78fe4b6f.png";